exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#wrapper[data-v-dc82be36] {\n    background-color: #fff;\n}\n", ""]);

// exports
